<template>
  <div class="absolute top-0 right-0 w-80 h-12 electron-no-drag z-[999999]" />
</template>
<script>
export default {
  name: 'ElectronFindInPageUnderlay',
};
</script>
